module.exports = __webpack_public_path__ + "img/H01117-112.303b7041.jpg";